
  import {Component, Vue} from "vue-property-decorator";
  import api from '@/api';
  import {OrganizationLevel, PermissionDefinitionDto} from "@/api/appService";
  import {createTableTree} from "@/utils/tree";
  import PermissionDefinitionEdit from "@/views/admin/permission/definition/edit.vue";


  @Component({
    components:{
      PermissionDefinitionEdit
    }
  })
  export default class PermissionDefinitionMaintain extends Vue{

    tableItems:PermissionDefinitionDto[] = [];
    isTableLoading= false;

    currentDataId?:number = 0;
    parentDataId:number  = 0;

    async created(){
      await this.fetchData();
    }

    formatLevels(row:PermissionDefinitionDto){
      if(!row.levels){
        return ''
      }
      let result:string[] = [];
      row.levels.forEach((level)=>{
        switch (level) {
          case OrganizationLevel.Store:
            result.push('门店');
            break;
          case OrganizationLevel.PartialArea:
            result.push('片区');
            break;
          case OrganizationLevel.BigArea:
            result.push('大区');
            break;
          case OrganizationLevel.Headquarters:
            result.push('总部');
            break;
        }
      });
      return result.join(',');
    }

    async fetchData(){
      this.isTableLoading = true;
      await api.permissionDefinition.getAll({maxResultCount:3234235,sorting:'displayOrder ascending'}).then(res=>{
        const tree = createTableTree(res.items!,
          'parentId',
          'id',
          null,
          'children');

        this.tableItems = tree;
        this.isTableLoading = false;
      })
    }

    handleCreateChild(row:PermissionDefinitionDto){
      this.currentDataId = undefined;
      this.parentDataId = row.id!;
      (this.$refs.permissionDefinitionEdit as any).show = true;

    }

    handleEdit(row:PermissionDefinitionDto){
      this.currentDataId = row.id;
      (this.$refs.permissionDefinitionEdit as any).show = true;
    }

    handleCreate(){
      this.parentDataId = 0;
      this.currentDataId = undefined;
      (this.$refs.permissionDefinitionEdit as any).show = true;
    }

    handleSave(){
      this.fetchData();
    }

    handleDelete(row:PermissionDefinitionDto){
      this.$confirm("你确定删除吗?", "提示").then(async () => {
        await api.permissionDefinition.delete({ id: row.id }).then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.fetchData();
        });
      });
    }


  }
